import { clearRedirectClientId, getRedirectClientId } from './clientIdStorage';
import { clearStoredClientId, createMsalConfig, getStoredClientId, storeClientId } from './msal.config';
import { clearClientIdFromUrl } from './urlState';

import { PublicClientApplication } from '@azure/msal-browser';

export const createMsalInstance = async (urlClientId: string | null): Promise<PublicClientApplication> => {
  const storedClientId = getStoredClientId();
  const redirectClientId = getRedirectClientId();
  const initialize = async (clientId: string | null): Promise<PublicClientApplication> => {
    const instance = new PublicClientApplication(createMsalConfig(clientId));
    await instance.initialize();
    const result = await instance.handleRedirectPromise();
    if (result?.account) {
      instance.setActiveAccount(result.account);
      clearClientIdFromUrl();
    }
    return instance;
  };

  // The v5 bridge can return a cached response without a code in the application URL.
  let instance = await initialize(redirectClientId ?? storedClientId ?? urlClientId);
  clearRedirectClientId();

  if (!instance.getActiveAccount()) {
    if (storedClientId) {
      clearStoredClientId();
    }
    const selectedConfig = createMsalConfig(urlClientId);
    if (instance.getConfiguration().auth.clientId !== selectedConfig.auth.clientId) {
      instance = await initialize(urlClientId);
    }
  }
  const account = instance.getActiveAccount();
  if (account) {
    storeClientId(instance.getConfiguration().auth.clientId);
  }
  return instance;
};
